import ThemeIcons from '../theme/Icons';

export default [
  { value: 'camera', label: 'Camera', icon: ThemeIcons.decorator.camera },
  { value: 'import', label: 'Import', icon: ThemeIcons.decorator.import },
  { value: 'paperclip', label: 'Paperclip', icon: ThemeIcons.decorator.paperclip },
  { value: 'image', label: 'Image', icon: ThemeIcons.decorator.image },
  { value: 'file', label: 'File', icon: ThemeIcons.decorator.file },
  { value: 'comment', label: 'Comment', icon: ThemeIcons.decorator.comment },
  { value: 'comments', label: 'Comments', icon: ThemeIcons.decorator.comments },
  { value: 'upload', label: 'Upload', icon: ThemeIcons.decorator.upload },
  { value: 'download', label: 'Download', icon: ThemeIcons.decorator.download },
  { value: 'rotate', label: 'Rotate', icon: ThemeIcons.decorator.rotate },
  { value: 'cloud', label: 'Cloud', icon: ThemeIcons.decorator.cloud },
  { value: 'filter', label: 'Filter', icon: ThemeIcons.decorator.filter },
  { value: 'share', label: 'Share', icon: ThemeIcons.decorator.share },
  { value: 'paper-plane', label: 'Paper Plane', icon: ThemeIcons.decorator.paperPlane },
  { value: 'folder', label: 'Folder', icon: ThemeIcons.decorator.folder },
  { value: 'folder-open', label: 'Folder Open', icon: ThemeIcons.decorator.folderOpen },
  { value: 'magnet', label: 'Magnet', icon: ThemeIcons.decorator.magnet },
  { value: 'eye', label: 'Eye', icon: ThemeIcons.decorator.eye },
  { value: 'circle-info', label: 'Info', icon: ThemeIcons.decorator.circleInfo },
  { value: 'plus', label: 'Plus', icon: ThemeIcons.decorator.plus },
  { value: 'flag', label: 'Flag', icon: ThemeIcons.decorator.flag },
];
